function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 248.3,
  cy: 231.2,
  fill: "#ffc043",
  rx: 218.2,
  ry: 197.8
});

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-icon-a",
  x1: 30.1,
  x2: 466.5,
  y1: 349.1,
  y2: 349.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ee7c45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#ee9643"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#edb144"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-icon-a)",
  d: "M425.5 384.6l4.4-5.7.8-1.1 4.3-6.1.2-.3 3.9-6.1.6-1 3.6-6.2.7-1.2 3.4-6.5.3-.6 3-6.4.4-1 2.8-6.7.5-1.4 2.5-6.8.3-.9 2.1-6.7.2-.8 1.9-7.1.3-1.4c.6-2.4 1.1-4.7 1.5-7.1l.2-1.2 1.2-7.2.1-.5.9-7.5.1-1.4.5-7.4.1-1.4.2-7.8v-38l-.2 7.8-.1 1.4-.5 7.4-.1 1.4-.9 7.5-.1.5a90 90 0 01-1.2 7.2l-.2 1.2-1.5 7.1-.3 1.4-1.9 7.1-.2.8-2.1 6.7-.3.9-2.5 6.8-.5 1.4-2.8 6.7-.4 1c-1 2.1-1.9 4.3-3 6.4l-.3.6-3.4 6.5-.7 1.2-3.6 6.2-.6 1-3.9 6.1-.2.3-4.3 6.1-.8 1.1-4.4 5.7-.9 1.1-4.8 5.8-.2.2-3.9 4.4-1.2 1.3-3.4 3.6-1 1a89.2 89.2 0 01-9.2 8.6l-1.3 1.2-4.7 4-4.9 3.9-1.4 1.1-4 3-1.2.9-5.1 3.6-1.2.8-4.1 2.7-1.6 1-4.6 2.8-.8.5-5.4 3.1-1.5.8-4.3 2.2-1.6.8-5.7 2.8-.2.1-5.6 2.5-1.7.7-4.5 1.9-1.6.6-6 2.2-3.5 1.2-1.3.4-4.9 1.6-1.1.3-3.8 1.1-1.8.5-3.2.9-2 .5-3 .7-2.2.5-2.9.6-2.2.5-2.9.6-2.3.4-2.9.5-2.3.4-2.9.4-2.3.3-2.9.4-2.3.3-3 .3-2.3.2-3.1.2-2.3.2-3.2.2-2.1.1-3.6.1-1.8.1-5.4.1a230.8 230.8 0 01-138.8-45.2 203.4 203.4 0 01-42.1-42l-2.9-4a202 202 0 01-21.2-38.6 180.2 180.2 0 01-13.2-68v38c0 109.2 97.7 197.8 218.2 197.8l5.4-.1 1.8-.1 3.6-.1 2.1-.1 3.2-.2 2.3-.2 3.1-.2 2.3-.2 3-.3 2.3-.3 2.9-.4 2.3-.3 2.9-.4 2.3-.4 2.9-.5 2.3-.4 2.9-.6 2.2-.5 2.9-.6 2.2-.5 3-.7 2-.5 3.2-.9 1.8-.5 3.8-1.1 1.1-.3 4.9-1.6 1.2-.4 3.3-1.1.2-.1 6-2.2 1.6-.6 4.5-1.8 1.7-.7a95 95 0 005.6-2.5l.2-.1 5.7-2.8 1.6-.8 4.3-2.2 1.5-.8 5.4-3.1.8-.5 4.6-2.8 1.6-1 4.1-2.7.9-.6.3-.2 5.1-3.6 1.2-.9 4-3 1.4-1.1 4.9-3.9 4.7-4 1.3-1.2a123 123 0 013.7-3.3l1.1-1 4.4-4.3.9-1 3.4-3.6 1.2-1.3 3.9-4.4.2-.2 4.8-5.8c.6-.5.9-.8 1.1-1.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-icon-b",
  x1: 75.1,
  x2: 421.5,
  y1: 231.2,
  y2: 231.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ee7c45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#ee9643"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#edb144"
}));

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 248.3,
  cy: 231.2,
  fill: "url(#token-icon-b)",
  rx: 173.2,
  ry: 152.8
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M300.7 171.4v20.1h-40.6v99.2h-25.4v-99.2h-40.5v-20.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  cx: 248.3,
  cy: 231.2,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20,
  rx: 170.4,
  ry: 150
}));

var SvgTokenIcon = function SvgTokenIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTokenIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/token-icon.352d853c.svg";
export { ForwardRef as ReactComponent };